module.exports = __webpack_public_path__ + "static/img/projectedArea.b2ff059.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/projectedArea.gif
// module id = jL3n
// module chunks = 0